if (!customElements.get('announcement-bar-dismiss')) {
	customElements.define(
		'announcement-bar-dismiss',
		class AnnouncementBarDismiss extends HTMLElement {
			constructor() {
				super()
				this.storageKey = `announcement-dismissed:${this.dataset.sectionId}`
				this.ttlMs = (parseInt(this.dataset.ttlDays, 10) || 30) * 86_400_000
			}

			connectedCallback() {
				if (this.isDismissed()) {
					this.hidden = true
					return
				}
				const button = this.querySelector('.announcement-bar__close')
				if (button) button.addEventListener('click', () => this.dismiss())
			}

			isDismissed() {
				try {
					const at = Number(window.localStorage.getItem(this.storageKey))
					return at > 0 && Date.now() - at < this.ttlMs
				} catch (_) {
					return false
				}
			}

			dismiss() {
				try {
					window.localStorage.setItem(this.storageKey, String(Date.now()))
				} catch (_) {
					/* storage unavailable — hide for this session only */
				}
				this.hidden = true
			}
		},
	)
}
